<template>
    <main :class="['review-topic-page', platformClass]">
        <button type="button" class="back-button" aria-label="返回" @click="goBack">
            <a-icon type="left"/>
        </button>

        <section class="topic-hero">
            <img class="hero-icon" src="@/asstes/review-assistant.png" alt="" aria-hidden="true">
            <h1>请选择标签，我来生成文案</h1>
        </section>

        <a-spin :spinning="loading" class="topic-loading">
            <section v-if="loadError" class="topic-state-card">
                <a-icon type="exclamation-circle"/>
                <strong>评价主题加载失败</strong>
                <span>{{ loadError }}</span>
                <button type="button" @click="loadTopics">重新加载</button>
            </section>

            <section v-else class="topic-grid" aria-label="评价主题列表">
                <button
                        v-for="topic in displayTopics"
                        :key="topic.id"
                        type="button"
                        class="topic-card"
                        :class="{'random-topic-card': topic.randomAll}"
                        :disabled="Boolean(navigatingTopicId)"
                        @click="openReviewContent(topic)"
                >
                    <a-icon v-if="topic.randomAll && navigatingTopicId !== topic.id" type="sync"/>
                    <span>{{ topic.topicName }}</span>
                    <a-icon v-if="navigatingTopicId === topic.id" type="loading"/>
                    <em v-else-if="topic.featured">推荐</em>
                </button>
            </section>
        </a-spin>

        <p class="topic-tip">点击标签，即可生成对应评价文案</p>
    </main>
</template>

<script>
import {getPublicReviewTopics} from '../../api/h5Page';

const UNCLASSIFIED_TOPIC_ID = 'UNCLASSIFIED';
const RANDOM_TOPIC_ID = 'RANDOM';

export default {
    name: 'ReviewTopicsPage',
    data() {
        return {
            loading: false,
            loadError: '',
            reviewTopics: [],
            navigatingTopicId: ''
        };
    },
    computed: {
        itemType() {
            return String(this.$route.query.type || '').trim();
        },
        plateNo() {
            return String(this.$route.query.sn || '').trim();
        },
        platformClass() {
            return {
                MEITUAN_REVIEW: 'platform-meituan',
                DIANPING_REVIEW: 'platform-dianping',
                GAODE_REVIEW: 'platform-gaode',
                DOUYIN_REVIEW: 'platform-douyin'
            }[this.itemType] || 'platform-douyin';
        },
        displayTopics() {
            const configuredTopics = this.reviewTopics.length ? this.reviewTopics : [{
                id: UNCLASSIFIED_TOPIC_ID,
                topicName: '综合评价',
                featured: false
            }];
            return configuredTopics.concat({
                id: RANDOM_TOPIC_ID,
                topicName: '随机评价',
                featured: false,
                randomAll: true
            });
        }
    },
    created() {
        this.loadTopics();
    },
    methods: {
        async loadTopics() {
            if (!this.plateNo || !this.itemType) {
                this.loadError = '缺少评价页面参数';
                return;
            }
            this.loading = true;
            this.loadError = '';
            try {
                this.reviewTopics = await getPublicReviewTopics(this.plateNo);
            } catch (error) {
                this.loadError = error.message || '无法获取评价主题';
            } finally {
                this.loading = false;
            }
        },
        async openReviewContent(topic) {
            if (this.navigatingTopicId) return;
            this.navigatingTopicId = topic.id;
            try {
                await this.$router.push({
                    path: '/app/review/content',
                    query: {
                        sn: this.plateNo,
                        type: this.itemType,
                        topicId: topic.id
                    }
                });
            } finally {
                this.navigatingTopicId = '';
            }
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
                return;
            }
            this.$router.replace({path: '/app', query: {sn: this.plateNo}});
        }
    }
};
</script>

<style scoped>
.review-topic-page {
    --theme-color: #171717;
    --theme-soft: rgba(23, 23, 23, .1);
    position: relative;
    box-sizing: border-box;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    padding: max(22px, env(safe-area-inset-top)) 22px calc(34px + env(safe-area-inset-bottom));
    overflow: hidden;
    color: #252525;
    background: linear-gradient(180deg, #fff 0%, #f7f7f7 34%, #e3e3e3 100%);
}

.review-topic-page::after {
    position: absolute;
    z-index: 0;
    right: -25%;
    bottom: -14%;
    width: 150%;
    height: 52%;
    border-radius: 50%;
    background: radial-gradient(circle, var(--theme-soft) 0%, rgba(255, 255, 255, 0) 68%);
    content: '';
    pointer-events: none;
}

.platform-meituan {
    --theme-color: #eabf00;
    --theme-soft: rgba(255, 205, 0, .34);
    background: linear-gradient(180deg, #fff 0%, #fffdf2 32%, #fff0a9 100%);
}

.platform-dianping {
    --theme-color: #ff7a1a;
    --theme-soft: rgba(255, 122, 26, .28);
    background: linear-gradient(180deg, #fff 0%, #fff9f4 30%, #ffe2c4 100%);
}

.platform-gaode {
    --theme-color: #1677ff;
    --theme-soft: rgba(22, 119, 255, .24);
    background: linear-gradient(180deg, #fff 0%, #f3f8ff 30%, #d9eaff 100%);
}

.back-button {
    position: relative;
    z-index: 2;
    display: flex;
    width: 38px;
    height: 38px;
    align-items: center;
    justify-content: center;
    margin-left: -8px;
    border: 0;
    border-radius: 50%;
    color: #343434;
    background: rgba(255, 255, 255, .66);
    font-size: 17px;
}

.topic-hero {
    position: relative;
    z-index: 1;
    padding: 48px 0 46px;
    text-align: center;
}

.hero-icon {
    display: block;
    width: 76px;
    height: 76px;
    object-fit: contain;
    margin: 0 auto 25px;
    filter: drop-shadow(0 10px 16px var(--theme-soft));
}

.topic-hero h1 {
    margin: 0;
    color: #252525;
    font-size: 23px;
    font-weight: 700;
    letter-spacing: .5px;
    line-height: 1.35;
}

.topic-hero p {
    margin: 11px 0 0;
    color: #8b8b8b;
    font-size: 13px;
}

.topic-loading,
.topic-loading /deep/ .ant-spin-container {
    position: relative;
    z-index: 1;
    min-height: 210px;
}

.topic-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
}

.topic-card {
    position: relative;
    display: flex;
    min-width: 0;
    min-height: 82px;
    align-items: center;
    justify-content: center;
    padding: 14px 18px;
    border: 1px solid rgba(255, 255, 255, .74);
    border-radius: 14px;
    color: #333;
    background: rgba(255, 255, 255, .91);
    box-shadow: 0 9px 24px rgba(52, 40, 25, .045);
    font-family: inherit;
    font-size: 16px;
    line-height: 1.45;
    text-align: center;
    transition: transform .16s ease, border-color .16s ease, box-shadow .16s ease;
}

.topic-card:active {
    border-color: var(--theme-color);
    box-shadow: 0 7px 18px var(--theme-soft);
    transform: scale(.98);
}

.topic-card:disabled {
    opacity: .7;
}

.topic-card span {
    overflow: hidden;
    text-overflow: ellipsis;
}

.topic-card em {
    position: absolute;
    top: 7px;
    right: 7px;
    padding: 2px 5px;
    border-radius: 6px;
    color: #fff;
    background: var(--theme-color);
    font-size: 9px;
    font-style: normal;
    line-height: 1.3;
}

.platform-meituan .topic-card em {
    color: #3a3100;
}

.topic-card .anticon-loading {
    position: absolute;
    right: 10px;
    color: var(--theme-color);
}

.random-topic-card {
    gap: 7px;
    border-style: dashed;
    color: var(--theme-color);
    background: rgba(255, 255, 255, .72);
}

.random-topic-card > .anticon {
    position: static;
    font-size: 15px;
}

.topic-state-card {
    display: flex;
    min-height: 210px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 24px;
    border-radius: 16px;
    background: rgba(255, 255, 255, .9);
    text-align: center;
}

.topic-state-card > .anticon {
    color: #a7a7a7;
    font-size: 34px;
}

.topic-state-card strong {
    margin-top: 14px;
    font-size: 16px;
}

.topic-state-card span {
    margin-top: 7px;
    color: #8b8b8b;
    font-size: 12px;
}

.topic-state-card button {
    margin-top: 18px;
    padding: 8px 20px;
    border: 0;
    border-radius: 18px;
    color: #fff;
    background: var(--theme-color);
}

.platform-meituan .topic-state-card button {
    color: #302800;
}

.topic-tip {
    position: relative;
    z-index: 1;
    margin: 26px 0 0;
    color: #9a9a9a;
    font-size: 12px;
    text-align: center;
}

@media (min-width: 520px) {
    .review-topic-page {
        width: 430px;
        margin: 0 auto;
        box-shadow: 0 0 50px rgba(25, 48, 83, .12);
    }
}
</style>
